<template>
  <v-card outlined>
    <v-card-text class="px-2 py-1">
      <v-list
        class="pa-0 suppliers-select-list"
        :class="$vuetify.breakpoint.name"
      >
        <v-list-item
          v-for="supplier in suppliers"
          :key="supplier.id"
          class="pa-0"
        >
          <v-list-item-content class="pa-0">
            <v-list-item-title>{{
              $options.filters.supplier(supplier)
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="ma-0 pa-0">
            <v-btn
              @click="removeSupplier(supplier)"
              icon
              :title="$t('actions.delete')"
              small
            >
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <SupplierSelectField
          :show-select-dialog-button="true"
          :show-add-dialog-button="true"
          :dense="true"
          @change="addSupplier"
          v-model="supplierToAdd"
          :label="$t('actions.add')"
        />
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import SupplierSelectField from '@/components/inputs/SupplierSelectField';

export default {
  name: 'MultipleSuppliersSelect',
  components: { SupplierSelectField },
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  computed: {
    suppliers: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
  },
  data: () => ({
    supplierToAdd: null,
  }),
  methods: {
    addSupplier(supplier) {
      if (!supplier) {
        return;
      }

      if (
        this.suppliers.some(
          (supplierInList) => supplierInList.id === supplier.id,
        )
      ) {
        this.supplierToAdd = null;
        return;
      }
      this.suppliers.push(supplier);
      this.supplierToAdd = null;
    },

    removeSupplier(supplierToRemove) {
      this.suppliers = this.suppliers.filter(
        (supplier) => supplier.id !== supplierToRemove.id,
      );
    },
  },
};
</script>

<style></style>
